/**
 * Published/Unpublished/Publishing… — a plain inert Badge, not a control.
 * Publishing lives in the row menu; this only ever displays state. See
 * design_handoff_calendars_index README §4 ("The badge is not a control")
 * and §7.3 (the row is its own progress indicator). Shared between the
 * widget index pages (Calendars, Alerts) — keyed only on `item.available`,
 * no item-type-specific copy.
 */
import React from "react";
import Badge from "../../theme/untitled/Badge/Badge";
import styles from "./StatusBadge.module.scss";

const StatusBadge = ({ item, isPublishing = false }) => {
  if (isPublishing) {
    return (
      <Badge color="gray" size="md">
        <span className={styles.spinner} aria-hidden="true" />
        Publishing&hellip;
      </Badge>
    );
  }

  return item.available ? (
    <Badge color="success" size="md" dot>
      Published
    </Badge>
  ) : (
    <Badge color="gray" size="md" dot>
      Unpublished
    </Badge>
  );
};

export default StatusBadge;
